import { setup } from './features/global/index.ts';

setup();
